import React from 'react'
import AboutIcon from '../../assets/img/logo/favicon.png';
import { Link } from 'react-router-dom';
import empowerImg from '../../assets/img/empower.png';
import Shape from '../../assets/img/shape-2.png';
import CardImg from '../../assets/img/bill.png';
import icon1 from '../../assets/img/solar_circle-top-up.png';
import icon2 from '../../assets/img/Vector.png';
import icon3 from '../../assets/img/interface.png';
import { Helmet } from "react-helmet-async";


function AirtimeBillPayment() {
    const dashboardBaseUrl = process.env.REACT_APP_DASHBOARD_BASE_URL;
    return (
        <>
            <Helmet>
                <title>Cardplot - Airtime & Bill Payments</title>
                <meta name="description" content="At Cardplot, we make your everyday transactions seamless and efficient with our Airtime & Bill Payment feature. Whether you're recharging your phone, paying utility bills, or settling subscriptions, our solution is designed to meet those needs." />
            </Helmet>
            <section className='breadcrumb__section__02 padding__tb__100'>
                <div className="container">
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className="breadcrumb__title__head">
                                <ol className="breadcrumb">
                                    <li className="active"><img src={AboutIcon} style={{ width: '25px', height: '25px' }} alt="" /></li>
                                </ol>
                                <h2 className='breadcrumb__title'> FEATURES </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="breadcrumb__text">
                                <h3 className='breadcrumb__text__head'>Airtime & Bill Payments</h3>
                                <p className='breadcrumb__text__content '>  
                                  At Cardplot, we make your everyday transactions seamless and efficient with our Airtime & Bill Payment feature. Whether you’re recharging your phone, paying utility bills, or settling subscriptions, our solution is designed to meet those needs.
                                </p>
                            </div>
                            <div className='d-flex gap-3 justify-content-center align-items-center' style={{ paddingTop: '40px' }}>
                                <Link to='' className='btn btn__primary'>Pay Bill / Buy Airtime</Link>
                                <Link to='/contact' className='btn btn__outline_primary '>Contact us</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='virtual__section payment__link__section padding__tb__100'>
                <div className='container'>
                    <div className='row justify-content-around align-items-center' >
                        <div className='col-12 col-md-7 mb-4 mb-lg-0 '>
                            <div className='virtual__section__content'>
                                <h3>
                                  Simplify Payments for your Essentials
                                </h3>
                                <p>
                                  With Cardplot’s Airtime and Bill Payment feature, you can easily top up your mobile phone or pay your bills seamlessly. 
                                </p>
                                <a className='btn btn__primary mt-4' href={`${dashboardBaseUrl}/getstarted`} target="_blank" rel="noopener noreferrer">
                                    Get Started
                                </a>
                            </div>
                        </div>
                        <div className='col-12 col-md-5 mb-4 mb-lg-0 '>
                            <div className='payment__link__section__image d-flex justify-content-end align-items-center'>
                                <img src={CardImg} className='img-fluid' alt='virtual cards' />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='create__virtual__card__section padding__tb__50'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='position-relative'>
                                <h2 className='create__virtual__card__section__title'>What you can expect:</h2>
                            </div>
                        </div>
                    </div>
                    <div className='bill__payment__section__content padding__tb__50'>
                        <div className="row">
                            <div className='bill__payment__section__content__item'>
                                <img src={icon1} className='img-fluid' alt="" />
                                <div className='bill__payment__section__content__left bill__payment__section__content__content'>
                                <h4>Instant Airtime Top-Up: </h4>
                                    <p>
                                        Purchase airtime for all major networks across Africa in just a few clicks. Whether you need to recharge your  phone or send airtime to family and friends, our platform makes it quick and easy    
                                    </p>
                                </div>
                            </div>
                            <div className='bill__payment__section__content__item'>
                                <img src={icon2} className='img-fluid' alt="" />
                                <div className='bill__payment__section__content__left bill__payment__section__content__content'>
                                <h4>Comprehensive Bill Payments:</h4>
                                    <p>
                                        Pay for essential services such as electricity, cable TV subscriptions (DSTV, GoTV, Startimes), and more—all from one convenient platform. Our service allows you to manage multiple payments in one place, saving you time and effort.   
                                    </p>
                                </div>
                            </div>
                            <div className='bill__payment__section__content__item'>
                                <img src={icon3} className='img-fluid' alt="" />
                                <div className='bill__payment__section__content__left bill__payment__section__content__content'>
                                    <h4>User-Friendly Interface: </h4>
                                    <p>
                                        Our intuitive platform ensures that even those new to digital payments can navigate with ease. Simply select the service, enter the required details, and complete your transaction in moments.  
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='empower_your_trade overlay'>
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-12 col-lg-6 mb-4 mb-lg-0">
                            <div className="empower__title">
                                <h2>Ready to simplify your payments?</h2>
                                <p>Simplify Your Exchange, Empower Your Trade</p>
                                <div className='d-flex gap-3' style={{ paddingTop: '60px' }}>
                                    <a className='btn btn__primary' href={`${dashboardBaseUrl}/getstarted`} target="_blank" rel="noopener noreferrer">
                                        Get Started
                                    </a>
                                    <Link to='/contact' className='btn btn__outline_primary'>Contact us</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-6 mb-4 mb-lg-0">
                            <div className="empower__img">
                                <img src={empowerImg} className='img-fluid' alt="empower" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AirtimeBillPayment